var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00156 10.1992H5.60156V15.7992H8.00156V10.1992Z",
    fill: "#528AFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2008 10.1992H10.8008V15.7992H13.2008V10.1992Z",
    fill: "#528AFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.4004H4V19.8004H20V17.4004Z",
    fill: "#528AFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 10.1992H16V15.7992H18.4V10.1992Z",
    fill: "#528AFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L4 7V8.6H20V7L12 3Z",
    fill: "#528AFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.4e4d639f.svg";
export { ForwardRef as ReactComponent };